import './index.css';

export default function Loader({ topAvance = 0}){
    let error = false;
    if(typeof topAvance === 'number'){
        topAvance += 'px';
    }else{
        error = 'Error en top avance';
        topAvance = '100px';
    }
    return(
        <div className="container-loader" style={{ paddingTop: topAvance }}>
            <div className={!error ? "loader" : '' }>{error}</div>
        </div>
    );
}